import React from "react";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";
import { ClinicalServiceTypes } from "../../../text/data";

const MedicationsHeader = ({
  showMeds,
  getFilterMenu,
  isIntervention,
  clinicalServiceName,
  onAddMedication,
  showInterectionTooltip,
  setShowInterectionTooltip,
  /** When true, hide +ADD (e.g. Patient chart → Rx - Pending Dispense tab). */
  suppressAddButton = false,
}) => {
  if (!showMeds) return null;

  // Determine if we're showing a Minor Ailment (Allergic Rhinitis) service
  const isMinorAilment = clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis;

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <h5 className="text-xl font-bold text-teal-300">
            Medications
          </h5>
          {getFilterMenu && getFilterMenu()}
        </div>
        {clinicalServiceName !== "AMR Education" && !suppressAddButton && (
          <div>
            <button
              className={`text-REELTeal text-xl font-semibold px-[5px] ${isMinorAilment ? "opacity-40 cursor-not-allowed" : ""}`}
              onClick={isMinorAilment ? undefined : onAddMedication}
              disabled={isMinorAilment}
              aria-disabled={isMinorAilment}
              data-tooltip-id={isMinorAilment ? "add-medication-no-access" : undefined}
            >
              +ADD
            </button>
            {isMinorAilment && (
              <NewToolTip
                id={"add-medication-no-access"}
                render={() => (
                  <div className="bg-white p-2 max-w-[300px] border border-gray-200 rounded shadow-lg">
                    <p className="text-sm text-gray-800">No access during <br /> minor ailments.</p>
                  </div>
                )}
              />
            )}
          </div>
        )}
      </div>
      
      {/* Interactions Results Button */}
      {!isIntervention && (
        <button
          className="m-0 h-[50px] flex text-center rounded-[4px] bg-white border-teal-50 hover:bg-opacity-70 text-white border transition-all duration-300 items-center font-semibold px-[8px] py-4"
          onClick={() => {
            setShowInterectionTooltip(!showInterectionTooltip);
          }}
          disabled={true}
          data-tooltip-id={"Interactions-note"}
        >
          <ReactSVG src="/icons/interactions.svg" className="pr-2" />{" "}
          <h3 className="text-base font-normal text-gray-800">
            Interactions
          </h3>
          {showInterectionTooltip && (
            <NewToolTip
              id={"Interactions-note"}
              render={() => (
                <div className="bg-white p-2  flex flex-col max-w-[400px] ">
                  <p className="text-teal-300 text-left text-body-sm font-normal">
                    Coming Soon
                  </p>
                </div>
              )}
            />
          )}
        </button>
      )}
    </>
  );
};

export default MedicationsHeader;
